import { useCheckIsB2BEnrichment } from '@aibees/shared/hooks';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import {
  CUSTOMER_ROOT_ENDPOINT,
  CUSTOMER_ROOT_ENDPOINT_B2B_ENRICHMENT,
} from '@aibees/shared/workspace/constants/endpoints';
import { ReadCustomerRequest, ReadCustomerResponse } from './types';

export function useReadCustomerApi(userId?: string) {
  const isEnrichment = useCheckIsB2BEnrichment();

  return useBaseQuery<ReadCustomerRequest, ReadCustomerResponse>(
    [useReadCustomerApi.name, userId],
    {
      url: `${
        isEnrichment
          ? CUSTOMER_ROOT_ENDPOINT_B2B_ENRICHMENT
          : `${CUSTOMER_ROOT_ENDPOINT}/${userId}`
      }`,
    }
  );
}
